import Component from '@glimmer/component';
import type EmployeeModel from 'tio-data/models/employee';
import type AccountingPaymentModel from 'tio-data/models/accounting-payment';
import BaseAccountingPayments from 'tio-common/components/contributions/accounting-payments';
import Table from './accounting-payments/table';
import Summary from 'tio-common/components/contributions/accounting-payments/summary';
import { hash } from '@ember/helper';

interface AccountingPaymentsSummaryData {
  total?: number | null;
}

export interface ContributionsAccountingPaymentsSignature {
  Args: {
    employee: EmployeeModel;
  };
  Blocks: {
    default: [
      {
        isLoaded: boolean;
        paymentData: AccountingPaymentModel[];
        summaryData: AccountingPaymentsSummaryData;
        table: unknown;
        summary: unknown;
      },
    ];
  };
}

export default class ContributionsAccountingPaymentsComponent extends Component<ContributionsAccountingPaymentsSignature> {
  <template>
    <BaseAccountingPayments @employee={{@employee}} as |base|>
      {{yield
        (hash
          paymentData=base.paymentData
          summaryData=base.summaryData
          isLoaded=base.isLoading
          table=(component Table model=base.paymentData isLoading=base.isLoading)
          summary=(component Summary model=base.summaryData isLoading=base.isLoading)
        )
      }}
    </BaseAccountingPayments>
  </template>
}
